// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion_Accordion__djmBE","AccordionHeader":"Accordion_AccordionHeader__7+5Ie","AccordionBody":"Accordion_AccordionBody__NTqSD","Expanded":"Accordion_Expanded__2GuWW"};